"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseError = void 0;
class ResponseError extends Error {
    constructor(name, message, status, errorDescriptions = []) {
        super(message);
        this.name = name;
        this.status = status;
        this.errorDescriptions = errorDescriptions;
    }
}
exports.ResponseError = ResponseError;
//# sourceMappingURL=ResponseError.js.map